import { JOB_STATUSES } from '../config/jobConstants';

// Check if job is overdue
export const isJobOverdue = (job) => {
  if (job.status === JOB_STATUSES.COMPLETED || job.status === JOB_STATUSES.CANCELLED) {
    return false;
  }
  
  const now = new Date();
  const scheduledDate = new Date(job.scheduled_date);
  return scheduledDate < now;
};

// Check if job is due today
export const isJobDueToday = (job) => {
  if (job.status === JOB_STATUSES.COMPLETED || job.status === JOB_STATUSES.CANCELLED) {
    return false;
  }
  
  const today = new Date();
  const scheduledDate = new Date(job.scheduled_date);
  
  return today.toDateString() === scheduledDate.toDateString();
};